import { resolveComponent as _resolveComponent, createVNode as _createVNode, Fragment as _Fragment, openBlock as _openBlock, createBlock as _createBlock, withScopeId as _withScopeId } from "vue"
const _withId = /*#__PURE__*/_withScopeId("data-v-1a175ebb")

export const render = /*#__PURE__*/_withId((_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) => {
  const _component_el_page_header = _resolveComponent("el-page-header")
  const _component_el_divider = _resolveComponent("el-divider")
  const _component_template_form = _resolveComponent("template-form")

  return (_openBlock(), _createBlock(_Fragment, null, [
    _createVNode(_component_el_page_header, {
      class: "margin-bottom-10",
      onBack: _ctx.goBack,
      content: "基础信息"
    }, null, 8, ["onBack"]),
    _createVNode(_component_el_divider),
    _createVNode(_component_template_form, {
      template: _ctx.template,
      onCancel: _cache[1] || (_cache[1] = ($event: any) => (_ctx.templateDialogVisible = false)),
      onSuccess: _cache[2] || (_cache[2] = ($event: any) => (_ctx.$router.push({ name: 'TemplateSlots' })))
    }, null, 8, ["template"])
  ], 64))
})